export default "__VITE_ASSET__B9pVPzT4__"